import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { SpotStatus } from '@frontend/spot/types';
import React from 'react';

const ID = 'spot-status-select';

export const SpotStatusSelect = (props: Omit<SelectInputV2Props<SpotStatus>, 'options'>) => {
    return (
        <SelectInputV2<SpotStatus>
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable ?? true}
            className={props.className}
            options={Object.values(SpotStatus).map((c) => ({ label: c.replace(/_/g, ' '), value: c }))}
            value={props.value}
            label={props.label || CommonMessage.OBJECTS.COMMON_FIELDS.STATUS}
            required={props.required}
            onSelect={props.onSelect}
        />
    );
};
